import { render, staticRenderFns } from "./ApprovalFlowUserChip.vue?vue&type=template&id=c8baf43e"
import script from "./ApprovalFlowUserChip.vue?vue&type=script&lang=js"
export * from "./ApprovalFlowUserChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports